import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import TextInput from "../common/TextInput";

interface LinkCarDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (plateNumbers: string[]) => void;
  title: string;
  submitButtonText: string;
}

export const LinkCarDialog: React.FC<LinkCarDialogProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  submitButtonText,
}) => {
  const [plateNumbers, setPlateNumbers] = useState<string[]>([]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    if (!form.checkValidity()) {
      e.stopPropagation();
      return;
    }

    if (plateNumbers.length > 0) {
      onSubmit(plateNumbers);
      setPlateNumbers([]);
      onClose();
    } else {
      const input = document.getElementById("plateNumber") as HTMLInputElement;
      if (input) {
        input.setCustomValidity("Please enter at least one plate number");
        input.reportValidity();
      }
    }
  };

  const handlePlateNumbersChange = (value: string | string[]) => {
    if (Array.isArray(value)) {
      setPlateNumbers(value);
    } else if (value) {
      setPlateNumbers([value]);
    } else {
      setPlateNumbers([]);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit} noValidate>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box mb={2}>
            <Typography variant="body1" color="textSecondary">
              Enter the vehicle's plate number to {title.toLowerCase()}:
            </Typography>
          </Box>
          <Box sx={{ marginTop: 2, marginBottom: 1 }}>
            <input
              type="text"
              required
              value={plateNumbers.join(",")}
              readOnly
              style={{ display: "none" }}
              aria-hidden="true"
            />
            <TextInput
              id="plateNumber"
              value={plateNumbers}
              onChange={handlePlateNumbersChange}
              placeholder="Enter plate numbers"
              style={{ width: "100%" }}
              autoFocus
              size="large"
              multiple
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            {submitButtonText}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
